/**
 * @generated SignedSource<<7efdf75117a5fa273f49f5f0a15dbac4>>
 * @relayHash f7117689bdd81ee360f2b94043895ce4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation$variables = {
  pageId: string;
  spaceKey: string;
};
export type MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation$data = {
  readonly movePageTopLevel: {
    readonly page: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation = {
  response: MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation$data;
  variables: MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          },
          {
            "kind": "Variable",
            "name": "targetSpaceKey",
            "variableName": "spaceKey"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MovePagePayload",
    "kind": "LinkedField",
    "name": "movePageTopLevel",
    "plural": false,
    "selections": [
      {
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7117689bdd81ee360f2b94043895ce4",
    "id": "3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2",
    "metadata": {},
    "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
    "operationKind": "mutation",
    "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id}}}"
  }
};
})();

(node as any).hash = "55c2c510926003ccb21aa81ad404b906";

export default node;
